import {
  GENERAL_RULES_CONSTANTS,
  TIME_UNITS
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar.vue";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import store from "@/store";
import { cloneDeep, isEqual } from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  DASHBOARD_OPERATORS,
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  DATA_TYPE,
  SPECIAL_FIELDS,
  RANGE_OPERATORS_LIST
} from "../../constants/DashboardTemplatesConstants";
import { Field } from "../../models/Field";
import {
  FilterField,
  FilterOfCollection
} from "../../models/FilterOfCollection";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { SelectCollection } from "./logic/SelectCollection";
@Component({
  name: "DashboardFilter",
  components: { DynamicSelect },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      actionInFilters: "getActionInFilters",
      totalFilters: "getTotalFilters"
    })
  }
})
export default class DashboardFilter extends Vue {
  @Prop() indexSectionOfDashboard!: number;
  @Prop() indexCollectionFilter?: number;
  @Prop() indexFilter!: number;
  @Prop() filter?: FilterOfCollection;
  @Prop() filters?: FilterOfCollection[];
  @Prop() collection?: DynamicSelectData;
  @Prop() optionsToIndicator?: DynamicSelectData[];
  @Prop() sizeFilter!: number;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  totalFilters!: number;

  actionInFilters!: {
    indexSection: number;
    indexCollection: number;
    indexFilter: number;
    field: string;
  };

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  Field = [] as DynamicSelectData[];
  lastField = [] as DynamicSelectData[];
  FieldConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false,
    disabled: false
  };
  lastDocId = "";
  menu = false;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  value: any = "";
  valueLastRange = 0;
  operator = [] as DynamicSelectData[];
  operatorConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false
  };

  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR_STRING_ARRAY
  ];

  requiredFieldRange = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.GREATER_THAN_ZERO
  ];

  valueOfField: DynamicSelectData[] | string[] = [];
  isUpdating = false;
  isSearchingOptions = false;

  // Para prevenir bucles en watchers
  lastFilterValue = "";
  lastValueOfField = "";
  lastTimeUnitSelected = "";
  lastOperator = "";
  valueOfFieldConfig: DynamicSelectConfig = {
    multiple: true,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true,
    attach: false,
    disabled: false,
    forceSearch: true,
    preventDeleteTheFirstElement: true
  };
  htmlElement = "";
  valueMin: number | null = null;
  valueMax: number | null = null;
  nowDate = new Date().toISOString().slice(0, 10);
  date: string[] | string = "";
  lastRef = "";
  timeUnitList = TIME_UNITS;
  timeUnitSelected = "year";
  basicClass = STYLE_CLASSES.BASIC_PRIMARY;

  updateQueryTimeout: number | null = null;
  valueOfFieldTimeout: number | null = null;
  lastkeyword = "";
  loadingAditionalContitions = false;
  isFromBlur = false;
  valuesList: DynamicSelectData[] = [];
  isPreloadig = false;
  isEditingSelect = false;
  valueOfFieldKey = 0;

  async mounted() {
    this.isPreloadig = true;
    this.lastFilterValue = JSON.stringify(this.filter);
    this.lastValueOfField = JSON.stringify(this.valueOfField);
    this.lastTimeUnitSelected = JSON.stringify(this.timeUnitSelected);
    this.lastOperator = JSON.stringify(this.operator);

    this.loadItems();
    await this.getCollectionProperties();

    if (this.filter && this.filter.value && this.filter.value.length > 0) {
      let value: any;
      if (typeof this.filter.value == "string") {
        value = this.filter.value;
      } else {
        if (
          (this.filter.field[0] as FilterField).type === DATA_TYPE.NUMBER &&
          Array.isArray(this.filter.value) &&
          this.filter.value.length === 2
        ) {
          this.valueMin = this.filter.value[0];
          this.valueMax = this.filter.value[1];
          return;
        }

        if (this.checkIfRangeOperator()) {
          this.valueLastRange = this.filter.value[0];
          this.timeUnitSelected = this.filter.value[1];
          this.htmlElement = "timeUnit";
          return;
        }

        const type =
          typeof this.filter.field == "string"
            ? this.filter.field
            : this.filter.field[0].type;
        if (type == "number" || type == "string") {
          value = this.filter.value[0].id;
        } else {
          value = [...this.filter.value];
        }
      }
      this.valueOfField = value;
      this.lastValueOfField = JSON.stringify(this.valueOfField);
    }
    if (
      this.valueOfField &&
      ((Array.isArray(this.valueOfField) && this.valueOfField.length == 1) ||
        !Array.isArray(this.valueOfField))
    ) {
      await this.aditionalContitions();
    }
  }

  beforeDestroy() {
    if (this.valueOfFieldTimeout) {
      clearTimeout(this.valueOfFieldTimeout);
    }
    if (this.updateQueryTimeout) {
      clearTimeout(this.updateQueryTimeout);
    }
  }

  @Watch("collection", { deep: true })
  onSectionsOfDashboardStoreChange() {
    this.FieldConfig.listAll = this.collection!.fields!.filter(
      (field: Field) => {
        return !field.showJustInGroupBy;
      }
    ).map((field: Field) => {
      return {
        id: field.field,
        name: field.visualField,
        operators: field.operators,
        type: field.type,
        idList: field.idList,
        child: field.child,
        additionalLogic: field.additionalLogic || ""
      };
    });
  }

  deleteDashboardFilter() {
    let valueFilled = false;
    if (this.valueOfField.length > 0 || this.value !== "") {
      valueFilled = true;
    }

    const validateFormTemplate = this.validateIfFormTemplateIsChosen();
    if (!validateFormTemplate) {
      Snackbar.popError(
        DASHBOARD_TEMPLATE_MESSAGES.THERE_ARE_FIELDS_THAT_DEPEND_ON_TEMPLATE
      );
      return;
    }

    this.$emit(
      "filterDeleted",
      this.indexFilter,
      valueFilled,
      this.Field[0]?.id
    );
  }

  validateIfFormTemplateIsChosen() {
    if (this.collection?.id !== "forms" && this.collection?.id !== "services") {
      return true;
    }

    if (
      this.Field[0]?.id !== "formTemplate" &&
      this.Field[0]?.id !== "serviceTemplate"
    ) {
      return true;
    }
    const filters = this.sectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter as number].filters;
    const formTemplate = filters.filter(filter =>
      SPECIAL_FIELDS.includes((filter.field[0] as FilterField)?.id)
    );
    if (formTemplate.length > 0) {
      return false;
    }

    return true;
  }

  @Watch("valueOfField")
  changeValueOfField(newValue: any, oldValue: any) {
    this.validVoidFields();
    this.pushValuesIfNotExistsInList();
    if (isEqual(oldValue, newValue)) return;
    this.onValueOfFieldChange();
  }

  setEditing(isEditing: boolean) {
    this.isEditingSelect = isEditing;
    this.validVoidFields();
  }

  @Watch("Field")
  @Watch("operator")
  @Watch("value")
  validVoidFields() {
    const hasField = this.Field?.length > 0;
    const hasOperator = this.operator?.length > 0;
    const hasValue = this.valueOfField?.length > 0 || this.value?.length > 0;

    const fieldWitchData = hasField && hasOperator && hasValue;
    this.$emit("isFilterEditing", this.isEditingSelect || !fieldWitchData);
  }

  async getCollectionProperties() {
    if (!this.filter) return;
    this.Field = this.filter.field as DynamicSelectData[];
    this.changeField(true);
    this.operator = this.filter.operator as DynamicSelectData[];

    this.pushValuesIfNotExistsInList();
    if (this.filter?.filterFromChart) {
      if ((this.filter.field[0] as FilterField).type === DATA_TYPE.LIST) {
        this.fixValueOfField();
      }
      this.changeValue(true);
    }

    if (this.Field[0]?.type === DATA_TYPE.TIME_STAMP) {
      this.value = (this.valueOfField as unknown) as string;
      this.date = (this.valueOfField as unknown) as string;
    }

    this.collection!.fields!.forEach((field: Field) => {
      const isSpecialField = this.verifyIfThereAreSpecialFieldsInGroupBy(
        field.field
      );
      if (!field.showJustInGroupBy && !isSpecialField) {
        this.FieldConfig.listAll.push({
          id: field.field,
          name: field.visualField,
          operators: field.operators,
          idList: field.idList,
          type: field.type,
          child: field.child,
          additionalLogic: field.additionalLogic || ""
        });
      }
    });
  }

  verifyIfThereAreSpecialFieldsInGroupBy(fieldId: string) {
    if (this.collection?.id !== "forms") {
      return false;
    }
    if (!SPECIAL_FIELDS.includes(fieldId)) {
      return false;
    }
    if (
      this.filter!.filterFromChart &&
      (this.filter?.field[0] as FilterField)?.id == fieldId
    ) {
      return false;
    }
    const specialFields = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[
      this.indexCollectionFilter as number
    ].groupBy.some((item: any) =>
      SPECIAL_FIELDS.includes(item?.id ? item.id : (item as string))
    );

    return specialFields;
  }

  verifyIfInStoreThereAreSpecialFields(fieldId: string) {
    if (this.collection?.id !== "forms" && this.collection?.id !== "services") {
      return true;
    }

    if (!SPECIAL_FIELDS.includes(fieldId)) {
      return true;
    }

    const filters = this.sectionsOfDashboardStore[this.indexSectionOfDashboard]
      .collections[this.indexCollectionFilter as number].filters;
    const specialFields = filters.filter(filter =>
      SPECIAL_FIELDS.includes((filter.field[0] as FilterField)?.id)
    );
    return !(specialFields.length > 0);
  }

  pushValuesIfNotExistsInList() {
    if (!Array.isArray(this.valueOfField)) {
      return;
    }

    const selectedValues = this.valueOfField as DynamicSelectData[];
    const selectedIds = new Set(selectedValues.map(v => v.id));

    const listWithoutSelected = this.valueOfFieldConfig.listAll.filter(
      item => !selectedIds.has(item.id)
    );

    this.valueOfFieldConfig.listAll = [
      ...selectedValues,
      ...listWithoutSelected
    ];
  }

  deleteFieldInStore() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.DELETE_FIELD_IN_STORE, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollectionFilter: this.indexCollectionFilter,
      field: this.lastField[0]?.id
    });
  }

  async changeField(isLoadingItems?: boolean) {
    if (!isLoadingItems && this.validateField()) {
      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.USED_FIELD);
      return;
    }

    const validateSpecialCaseInfoForm = this.verifySpecialCase();
    if (!validateSpecialCaseInfoForm) {
      return;
    }
    this.valueOfFieldConfig.listAll = [];
    if (!isLoadingItems) {
      this.deleteFieldInStore();
    }
    await this.getValues("", true);
    this.lastField = this.Field;
    if (this.Field.length == 0) return;
    const isSpecialField = SPECIAL_FIELDS.includes(this.Field[0].id);
    if (this.Field[0].operators) {
      this.operatorConfig.listAll = this.Field[0].operators
        .split(",")
        .map(operator => ({
          id: this.mapIdOperator(operator),
          name: operator
        }));
      this.operatorConfig.disabled = false;
      this.valueOfFieldConfig.multiple = true;
      if (!isLoadingItems && !isSpecialField) {
        this.valueOfField = [];
      }
      return;
    }

    this.operatorConfig.listAll = [{ id: "=", name: "=" }];
    this.operator = [{ id: "=", name: "=" }];
    this.operatorConfig.disabled = true;
    this.valueOfFieldConfig.multiple = false;
    if (!isLoadingItems && !isSpecialField) {
      this.valueOfField = [];
    }
  }

  verifySpecialCase() {
    if (this.collection?.id !== "forms" && this.collection?.id !== "services") {
      return true;
    }

    if (SPECIAL_FIELDS.includes(this.Field[0]?.id)) {
      const filters = this.sectionsOfDashboardStore[
        this.indexSectionOfDashboard
      ].collections[this.indexCollectionFilter as number].filters;
      const template = filters.filter(
        filter =>
          (filter.field[0] as FilterField)?.id == "formTemplate" ||
          (filter.field[0] as FilterField)?.id == "serviceTemplate"
      );
      if (template.length > 0) {
        return true;
      }

      Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.MUST_CHOOSE_TEMPLATE);
      return false;
    }

    return true;
  }

  validateField() {
    const fieldFound = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[this.indexCollectionFilter as number].filters.find(
      item => (item.field[0] as FilterField)?.id == this.Field[0].id
    );
    if (fieldFound) {
      return true;
    }
    return false;
  }

  mapIdOperator(operator: string) {
    if (operator == DASHBOARD_OPERATORS.BETWEEN) return "BETWEEN";
    if (operator == DASHBOARD_OPERATORS.RANGE) return "range";
    return operator;
  }

  checkIfRangeOperator() {
    return this.operator[0]?.id === "range";
  }

  async getValues(keyword = "", changeField?: boolean) {
    if (
      this.valueOfFieldConfig.listAll.length > 0 &&
      this.lastDocId == "" &&
      !changeField &&
      this.lastkeyword == keyword
    ) {
      return;
    }
    this.lastkeyword = keyword as string;
    if (this.Field.length == 0) return;

    this.htmlElement = this.Field[0].type as string;
    if (this.Field[0].type !== DATA_TYPE.LIST) {
      return;
    }
    this.isSearchingOptions = true;
    const selectCollection = new SelectCollection();
    const listOfPropertiesValues =
      selectCollection[this.collection!.id as keyof SelectCollection];
    listOfPropertiesValues.setIndexes(
      this.indexSectionOfDashboard,
      this.indexCollectionFilter!
    );
    if (keyword || changeField) {
      this.lastDocId = "";
    }
    const fetchData = await listOfPropertiesValues.loadItems(
      this.Field[0].id,
      this.Field[0].idList,
      keyword || "",
      this.lastDocId
    );
    this.isSearchingOptions = false;
    if (this.lastField[0]?.id !== this.Field[0].id) {
      this.valuesList = fetchData?.data || [];
      this.valueOfFieldConfig.listAll = fetchData?.data || [];
    } else {
      this.valuesList = cloneDeep(this.valueOfFieldConfig.listAll).concat(
        fetchData?.data || []
      );
      this.valueOfFieldConfig.listAll = cloneDeep(
        this.valueOfFieldConfig.listAll
      ).concat(fetchData?.data || []);
    }
    if (fetchData?.lastDocId) {
      this.lastDocId = fetchData.lastDocId;
    } else {
      this.lastDocId = "";
    }

    this.caseSpecialFields();

    if (this.filter!.filterFromChart) {
      const valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
        item =>
          item.id ===
            (this.filter!.value[0 as number] as DynamicSelectData)!.id ||
          item.name.toLocaleUpperCase() ===
            (this.filter!.value[
              0 as number
            ] as DynamicSelectData)!.name.toLocaleUpperCase()
      );

      if (!valueOfFieldFound) {
        if (!this.isUpdating && this.valueOfField.length === 0) {
          this.valueOfField = [];
        }
        return;
      }

      if (!this.isUpdating) {
        this.valueOfField = [
          { id: valueOfFieldFound?.id, name: valueOfFieldFound?.name }
        ];
      }
    }
  }

  caseSpecialFields() {
    this.valueOfFieldConfig.disabled = false;
    this.operatorConfig.disabled = false;

    if (this.collection?.id !== "forms" && this.collection?.id !== "services") {
      return;
    }
    const field = this.Field[0].id;
    if (!SPECIAL_FIELDS.includes(field)) {
      return;
    }

    const newValues = [...this.valueOfFieldConfig.listAll];
    this.valueOfField = [];
    this.$nextTick(() => {
      this.operator = [{ id: "=", name: "=" }];
      this.isFromBlur = true;
      this.valueOfField = newValues;
      this.valueOfFieldConfig.disabled = true;
      this.operatorConfig.disabled = true;
    });
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.SPECIAL_FIELD_SELECTED, true);
  }

  @Watch("valuesList")
  onValuesListChange() {
    this.pushValuesIfNotExistsInList();
  }

  @Watch("timeUnitSelected")
  onValueOfFieldChange() {
    if (
      this.htmlElement === "list" &&
      this.valueOfFieldConfig.multiple &&
      !this.isFromBlur
    ) {
      if (this.totalFilters > 0) {
        store.commit(DASHBOARD_TEMPLATE_EVENTS.REDUCE_TOTAL_FILTERS);
      }
      return;
    }
    if (
      (this.htmlElement == "text" ||
        this.htmlElement == "number" ||
        this.htmlElement == "timeUnit") &&
      !this.isFromBlur
    ) {
      if (this.totalFilters > 0) {
        store.commit(DASHBOARD_TEMPLATE_EVENTS.REDUCE_TOTAL_FILTERS);
      }
      return;
    }
    if (this.isFromBlur) {
      this.isFromBlur = false;
    }
    const currentValueOfField = JSON.stringify(this.valueOfField);
    const currentTimeUnit = JSON.stringify(this.timeUnitSelected);

    if (
      this.lastValueOfField === currentValueOfField &&
      this.lastTimeUnitSelected === currentTimeUnit
    ) {
      return;
    }
    this.lastValueOfField = currentValueOfField;
    this.lastTimeUnitSelected = currentTimeUnit;
    this.changeValue(false);
  }

  changeValue(executeWhenFilterComeFromChart = false) {
    if (this.valueOfField.length == 0) return;
    if (
      this.Field?.[0]?.type === DATA_TYPE.LIST &&
      !executeWhenFilterComeFromChart &&
      !this.filter?.filterFromChart
    ) {
      if (this.isSearchingOptions) {
        return;
      }
      const allAreSelectedOptions = (this.valueOfField as unknown[]).every(
        v => {
          if (typeof v === "string") return false;
          if (
            typeof v === "object" &&
            v !== null &&
            (v as DynamicSelectData).id
          )
            return true;
          return false;
        }
      );
      if (!allAreSelectedOptions) {
        return;
      }
    }
    if (this.Field[0].type == DATA_TYPE.TIME_UNIT) {
      this.Field[0].description = this.timeUnitSelected;
    }
    this.aditionalContitions();
    const filter: {
      field: DynamicSelectData[];
      operator: DynamicSelectData[];
      value: DynamicSelectData[] | string[];
      id?: string;
      filterFromChart?: boolean;
    } = {
      field: this.Field,
      operator: this.operator,
      value: this.valueOfField,
      id: this.filter?.id
    };
    if (this.filter?.filterFromChart || executeWhenFilterComeFromChart) {
      filter.filterFromChart = true;
      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
        indexSectionOfDashboard: this.indexSectionOfDashboard,
        indexCollection: this.indexCollectionFilter,
        indexFilter: this.indexFilter,
        filter: filter
      });

      store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_ACTIONS_IN_FILTERS, {
        indexSection: this.indexSectionOfDashboard,
        indexCollection: this.indexCollectionFilter,
        indexFilter: this.indexFilter,
        field: this.Field[0].id
      });
      this.checkEmitUpdateQuery();
      return;
    }
    this.commitFilter(filter);
  }

  checkEmitUpdateQuery() {
    const storeFiltersCollection = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[this.indexCollectionFilter as number].filters;

    if (this.sizeFilter == storeFiltersCollection.length) {
      for (const filter of storeFiltersCollection) {
        if (filter == undefined) return;
      }
      this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
    }
  }

  fixOperator(operator: DynamicSelectData[]) {
    if (this.checkIfRangeOperator()) {
      return [{ name: "Entre", id: "BETWEEN" }];
    }
    return operator;
  }

  commitFilter(filter: {
    field: DynamicSelectData[];
    operator: DynamicSelectData[];
    value: DynamicSelectData[] | string[];
    filterFromChart?: boolean;
  }) {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      filter: filter
    });
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_ACTIONS_IN_FILTERS, {
      indexSection: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      field: this.Field[0].id
    });
    if (this.totalFilters > 0) {
      store.commit(DASHBOARD_TEMPLATE_EVENTS.REDUCE_TOTAL_FILTERS);
      return;
    }
    this.checkEmitUpdateQuery();
  }

  @Watch("filter")
  changeFilter() {
    if (!this.filter) return;

    const currentFilter = JSON.stringify(this.filter);
    if (
      this.lastFilterValue === currentFilter &&
      !this.filter.filterFromChart
    ) {
      return;
    }

    this.lastFilterValue = currentFilter;

    if (
      JSON.stringify(this.valueOfField) !== JSON.stringify(this.filter.value) ||
      this.filter.filterFromChart
    ) {
      if (
        (this.filter.field[0] as FilterField).type === DATA_TYPE.LIST &&
        this.filter.filterFromChart
      ) {
        this.fixValueOfField();
      } else {
        this.operator = cloneDeep(this.filter.operator) as DynamicSelectData[];

        this.valueOfField = [...this.filter.value];

        if (this.Field[0].type == DATA_TYPE.TIME_STAMP) {
          const normalizedValue = this.normalizeFilterValue(this.filter.value);
          this.value = normalizedValue;
          this.date = normalizedValue;
        }
      }
    }
  }

  fixValueOfField() {
    let valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
      item => item.id === this.filter!.value[0].id
    );
    if (!valueOfFieldFound) {
      valueOfFieldFound = this.valueOfFieldConfig.listAll.find(
        item =>
          item.name.toLocaleUpperCase() ===
          this.filter!.value[0].name.toLocaleUpperCase()
      );
    }
    if (valueOfFieldFound) {
      this.valueOfField = [
        {
          id: valueOfFieldFound?.id as string,
          name: valueOfFieldFound?.name as string
        }
      ];
    }
  }

  loadItems() {
    if (this.filter?.field && this.filter?.field.length > 0) {
      console.log("carghando items", this.filter.field);
      this.Field = this.filter.field as FilterField[];
      this.operator = cloneDeep(this.filter.operator) as DynamicSelectData[];

      if (!this.isUpdating) {
        this.valueOfField = JSON.parse(JSON.stringify(this.filter.value));
      }

      if ((this.filter.field[0] as FilterField).type == DATA_TYPE.TIME_STAMP) {
        this.date = cloneDeep(this.filter.value);
        this.value = this.date;
      }

      if (this.Field[0].type == DATA_TYPE.TIME_UNIT) {
        this.timeUnitSelected = (this.filter.field[0] as FilterField)
          .description as string;
      }
    }
  }

  changeOperatorEvent() {
    this.cleanValues();
  }

  @Watch("operator")
  changeOperator() {
    this.htmlElement = this.Field[0]?.type as string;
    const currentOperator = JSON.stringify(this.operator);
    if (this.lastOperator === currentOperator) {
      return;
    }

    if (this.operator[0].id == "BETWEEN") {
      this.date = [];
    }

    if (this.operator[0].id == "range") {
      this.htmlElement = "timeUnit";
      this.timeUnitList = RANGE_OPERATORS_LIST.map(item => ({
        label: item.name,
        value: item.id
      }));
      this.timeUnitSelected = "lastWeeks";
    }

    if (this.lastOperator == "[]") {
      this.lastOperator = currentOperator;
      return;
    }
    this.lastOperator = currentOperator;
    const isTimestamp = this.Field[0]?.type === "timestamp";
    const hasOperator = !!this.operator[0];
    if (isTimestamp && hasOperator) {
      const isBetweenOperator = hasOperator && this.operator[0].id == "BETWEEN";
      const valueCount = this.valueOfField.length;
      const firstValue = this.valueOfField[0] as string;
      if (isBetweenOperator && valueCount == 1) {
        this.date = [firstValue, firstValue];
        return;
      }
      if (!isBetweenOperator && valueCount == 2) {
        this.date = firstValue;
        return;
      }
    }

    if (this.filter?.filterFromChart) {
      return;
    }
    this.valueOfField = [];
  }

  cleanValues() {
    this.valueOfField = [];
    this.date = [];
    this.value = "";
    this.menu = false;
    this.valueLastRange = 0;
  }

  saveDate(date: string | string[]) {
    if (Array.isArray(date)) {
      if (date.length === 1) {
        Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.MUST_BE_RANGE);
        return;
      }

      const date1 = new Date(date[0]).getTime();
      const date2 = new Date(date[1]).getTime();

      if (date1 > date2) {
        date = [date[1], date[0]];
      }
    } else {
      date = [date];
    }
    this.value = date;
    this.menu = false;
    this.date = date;
    const filter = {
      field: this.Field,
      operator: this.operator,
      value: this.date,
      id: this.filter?.id
    };
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      filter: filter
    });
    //TODO pendiete validacion
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
  }

  rangeValue() {
    if (!this.valueMin || !this.valueMax) return;

    if (this.valueMin >= this.valueMax) {
      Snackbar.popError("El valor máximo debe ser mayor al valor mínimo");
      this.valueMin = null;
      return;
    }

    const filter = {
      field: this.Field,
      operator: this.operator,
      value: [this.valueMin, this.valueMax],
      id: this.filter?.id
    };
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_FILTER_ITEM, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indexCollection: this.indexCollectionFilter,
      indexFilter: this.indexFilter,
      filter: filter
    });
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_QUERY);
  }

  @Watch("actionInFilters")
  changeActionInFilters() {
    if (
      this.actionInFilters.indexSection == this.indexSectionOfDashboard &&
      this.actionInFilters.indexCollection == this.indexCollectionFilter &&
      this.actionInFilters.indexFilter !== this.indexFilter &&
      this.Field[0]?.child
    ) {
      const valueFound = this.sectionsOfDashboardStore[
        this.indexSectionOfDashboard
      ].collections[this.indexCollectionFilter as number].filters.find(
        item => (item.field[0] as FilterField)?.id == this.Field[0].child
      );

      if (valueFound) {
        this.FieldConfig.disabled = true;
        this.valueOfFieldConfig.disabled = true;
        return;
      }

      if (!valueFound && this.Field[0].child == this.actionInFilters.field) {
        this.FieldConfig.disabled = true;
        this.valueOfFieldConfig.disabled = true;
        return;
      }

      this.FieldConfig.disabled = false;
      this.valueOfFieldConfig.disabled = false;
    }
  }

  setTimeUnit(timeUnit: { label: string; value: string }) {
    this.isFromBlur = true;
    if (this.checkIfRangeOperator()) {
      this.valueOfField = [this.valueLastRange.toString(), timeUnit.value];
      this.timeUnitSelected = timeUnit.value;
      return;
    }
    this.timeUnitSelected = timeUnit.value;
  }

  @Watch("valueLastRange")
  changeValueLastRange() {
    this.valueOfField = [this.valueLastRange.toString(), this.timeUnitSelected];
    this.isFromBlur = true;
  }

  getMoreData(event: string) {
    this.getValues(event);
  }

  normalizeFilterValue(value: any): string | string[] {
    if (!value) return "";

    if (Array.isArray(value)) {
      const dates = value
        .map(item => {
          if (typeof item === "string") return item;
          if (typeof item === "object" && item && item.id) return item.id;
          if (typeof item === "object" && item && item.name) return item.name;
          return String(item);
        })
        .filter(d => d && d !== "null" && d !== "undefined");

      return dates.length === 1 ? dates[0] : dates;
    }

    if (typeof value === "object" && value) {
      return value.id || value.name || String(value);
    }

    return String(value);
  }

  async aditionalContitions() {
    try {
      if (!this.Field[0]?.additionalLogic) return;
      const selectCollection = new SelectCollection();
      const listOfPropertiesValues =
        selectCollection[this.collection!.id as keyof SelectCollection];

      const additionalfunction = (listOfPropertiesValues as any)[
        this.Field[0].additionalLogic
      ].bind(listOfPropertiesValues);

      if (!additionalfunction) return;
      this.loadingAditionalContitions = true;
      store.commit("setFetchData", true);
      listOfPropertiesValues.setIndexes(
        this.indexSectionOfDashboard,
        this.indexCollectionFilter!
      );
      const response = await additionalfunction(
        this.valueOfField,
        this.indexSectionOfDashboard
      );
      store.commit("setFetchData", false);

      for (const item of response) {
        if (item.function && item.data) {
          this[item.function as keyof DashboardFilter](item.data);
        }
      }

      this.$emit("aditionalConditionsApplied", true);
    } catch (error) {
      store.commit("setFetchData", false);
    }
  }

  addNewField(data: {
    id: string;
    name: string;
    fields: any[];
    operators?: string;
    listId?: string;
    type?: string;
    additionalLogic?: string;
    isFormField?: string;
    formTemplate?: string;
  }) {
    this.$emit("addNewField", {
      field: data.id,
      visualField: data.name,
      operators: data.operators ?? "",
      type: data.type ?? "text",
      fields: data.fields,
      idList: data.listId ?? "",
      additionalLogic: data.additionalLogic ?? "",
      isFormField: data.isFormField,
      formTemplate: data.formTemplate ?? ""
    });
  }

  removeField(data: { id: string; name: string }) {
    this.$emit("removeField", data.id);
  }

  removeFormFields() {
    this.$emit("removeFormFields");
  }

  shouldHandleBlur() {
    return this.valueOfFieldConfig.multiple;
  }

  onValueOfFieldBlur() {
    this.isFromBlur = true;
    if (this.checkIfRangeOperator()) {
      return;
    }
    this.onValueOfFieldChange();
  }

  onTextFieldBlur() {
    this.isFromBlur = true;
    this.onValueOfFieldChange();
  }
}
